import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  template: `<span class="label {{ 'siteStatus-' + status }}">{{ 'SiteStatus.' + status | translate }}</span>`,
  styleUrls: ['./site-status.component.scss'],
  selector: 'app-site-status',
  imports: [TranslatePipe],
})
export class SiteStatusComponent {
  @Input() status: string;
}
